import { SpecialDetailStatus } from '@iheartjane/menu';
import { useFetcher, useNavigate } from 'react-router';

import type { CartActionResult } from '@jane/bloom/actions/cart.server';
import { useCheckoutLink } from '@jane/bloom/hooks/useCheckoutLink';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { useBrandSpecialShortfallNotice } from '@jane/bloom/providers/brandSpecialShortfallProvider';
import { CartAction } from '@jane/bloom/routes/api.cart-items/types';
import type { BrandSpecialViewModel } from '@jane/bloom/viewModels/brandSpecialViewModel';

export const GoldBundleProgress = ({
  brandSpecial,
  tagLabel,
}: {
  brandSpecial: BrandSpecialViewModel;
  tagLabel: string;
}) => {
  const { promoCode } = useRootLoaderData();
  const checkoutUrl = useCheckoutLink({ promoCode });
  const navigate = useNavigate();
  const fetcher = useFetcher<CartActionResult>();
  useBrandSpecialShortfallNotice(fetcher.data);

  const handleRemoveProduct = (product: { id?: number; price_id?: string }) => {
    fetcher.submit(
      {
        intent: CartAction.DeleteItem,
        priceId: product.price_id ?? null,
        productId: product.id?.toString() ?? null,
      },
      {
        action: `/api/cart-items`,
        method: 'POST',
      }
    );
  };

  return (
    <>
      <SpecialDetailStatus.BundleProgress
        allowQualifiersToBeDiscounted={
          brandSpecial.allowQualifiersToBeDiscounted
        }
        calloutSubtext={brandSpecial.calloutSubtext}
        calloutText={brandSpecial.calloutText}
        discountedProducts={brandSpecial.discountedProducts}
        isGold
        onRemoveProduct={handleRemoveProduct}
        qualifiedProducts={brandSpecial.qualifiedProducts}
        qualifyingStatus={brandSpecial.qualifyingStatus}
        tagLabel={tagLabel}
      />
      <SpecialDetailStatus.Footer
        footerSubtext={brandSpecial.footerSubtext}
        footerText={brandSpecial.footerText}
        isGold
        onCheckoutClick={() => navigate(checkoutUrl)}
        qualifyingStatus={brandSpecial.qualifyingStatus}
      />
    </>
  );
};
